import authEnums from '../common/enums';

function pwdStengthEvaluation(pwd, minPwdLength) {
  //deciding the min length of passwords as support users have a higher minimum char password limit
  if (pwd.length <= 0) {
    return {
      progressBarLabel: '',
      progressBarRank:  authEnums.pwdStrengthRanks.X0.rank,
      progressBarColor: authEnums.pwdStrengthRanks.X0.color,
      isPasswordValid:  false,
    };
  }

  if (pwd.length < minPwdLength) {
    return {
      progressBarLabel: authEnums.pwdStrengthText.TOOSHORT,
      progressBarRank:  authEnums.pwdStrengthRanks.X0.rank,
      progressBarColor: authEnums.pwdStrengthRanks.X0.color,
      isPasswordValid:  false,
    };
  }
  if (pwd.length > authEnums.pwdStrengthLimits.MAX_LENGTH) {
    return {
      progressBarLabel: authEnums.pwdStrengthText.TOOLONG,
      progressBarRank:  authEnums.pwdStrengthRanks.X0.rank,
      progressBarColor: authEnums.pwdStrengthRanks.X0.color,
      isPasswordValid:  false,
    };
  }

  //might wanna consider installing this via yarn and have it imported ?
  switch (zxcvbn(pwd).score) {
    case 0:
      return {
        progressBarLabel: authEnums.pwdStrengthText.X1,
        progressBarRank:  authEnums.pwdStrengthRanks.X1.rank,
        progressBarColor: authEnums.pwdStrengthRanks.X1.color,
        isPasswordValid:  false,
      };

    case 1:
      return {
        progressBarLabel: authEnums.pwdStrengthText.X2,
        progressBarRank:  authEnums.pwdStrengthRanks.X2.rank,
        progressBarColor: authEnums.pwdStrengthRanks.X2.color,
        isPasswordValid:  false,
      };

    case 2:
      return {
        progressBarLabel: authEnums.pwdStrengthText.X3,
        progressBarRank:  authEnums.pwdStrengthRanks.X3.rank,
        progressBarColor: authEnums.pwdStrengthRanks.X3.color,
        isPasswordValid:  false,
      };

    case 3:
      return {
        progressBarLabel: authEnums.pwdStrengthText.X4,
        progressBarRank:  authEnums.pwdStrengthRanks.X4.rank,
        progressBarColor: authEnums.pwdStrengthRanks.X4.color,
        isPasswordValid:  true,
      };

    case 4:
      return {
        progressBarLabel: authEnums.pwdStrengthText.X5,
        progressBarRank:  authEnums.pwdStrengthRanks.X5.rank,
        progressBarColor: authEnums.pwdStrengthRanks.X5.color,
        isPasswordValid:  true,
      };
  }
}

const BROWSER_SUPPORT = {
  CHROME:  61,
  SAFARI:  10,
  FIREFOX: 56,
  EDGE:    15,
};

function browserDetection() {
  let ua = window.navigator.userAgent,
    tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null)
      return tem
        .slice(1)
        .join(' ')
        .replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(' ');
}

function isSupportedBrowser() {
  const detectedBrowser = browserDetection().split(' '),
    browserName = detectedBrowser[0].toUpperCase(),
    browserVersion = detectedBrowser[1];
  return !!(BROWSER_SUPPORT[browserName] && BROWSER_SUPPORT[browserName] <= browserVersion);
}

function rePasswordValidationHelper(password, repassword, isPasswordValid) {
  let rePasswordCorrect = repassword.length > 0 && password.length > 0 ? password === repassword : true;
  let rePasswordErrorMessage = rePasswordCorrect ? '' : 'Confirmation password does not match';

  if (isPasswordValid && repassword.length === 0) {
    rePasswordErrorMessage = 'Please confirm your password before proceeding.';
    rePasswordCorrect = false;
  }

  return { rePasswordErrorMessage, rePasswordCorrect };
}

export { pwdStengthEvaluation, isSupportedBrowser, rePasswordValidationHelper };
